import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { moveTeamMembers } from './types';

import { requestMoveTeamMembersSuccess, requestMoveTeamMembersFailure } from './actions';

import { requestMyCompanyTeams } from '../../teams/actions';

const logger = new Logger('Saga:TeamWizzard:MoveTeamMembers');

export function* requestMoveTeamMembersSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.put,
      routerService.generate('api.teams.move_team_members', { teamId: action.targetTeamId }),
      { userIds: action.memberIds },
    );

    yield put(requestMoveTeamMembersSuccess(response.data));
    // Refresh the current user teams
    yield put(requestMyCompanyTeams());
  } catch (error) {
    logger.error('Failed to update team role with the following error', error);
    yield put(requestMoveTeamMembersFailure(error));
  }
}

export default function* moveTeamMembersSaga() {
  return yield all([takeLatest(moveTeamMembers.request, requestMoveTeamMembersSaga)]);
}
